export default __webpack_public_path__ + "static/hurdle-linear-background-a75329199827f8de9e6cfe4f505fbf3b.png";